import { useLocation, useNavigate, useParams } from "react-router-dom";
import Pagination from "../../../../component/molecules/pagination";
import { useEffect, useState } from "react";
import Td from "../../../../component/atoms/layout/table/td";
import DetailBtn from "../../../../component/atoms/button/detailBtn";
import { route } from "../../../../router/route";
import scrollToTop from "../../../../util/scrollToTop";
import TableText from "../../../../component/atoms/text/table/tableText";
import PretendardText from "../../../../component/atoms/text/pretendardText";
import { formatNumberWithCommas } from "../../../../util/formatNumber";
import { fileUrl } from "../../../../api/api";
import moment from "moment";
import Th from "../../../../component/atoms/layout/table/th";
import Tr from "../../../../component/atoms/layout/table/tr";
import Table from "../../../../component/atoms/layout/table/table";
import { errorHandler } from "../../../../util/errorHandler";
import OrderApi from "../../../../api/order.api";
import Checkbox from "../../../../component/atoms/input/checkbox";
import styled from "styled-components";
import Empty from "../../../../component/molecules/empty";
import Pagination2 from "../../../../component/molecules/pagination2";

const BuyList = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const pathName = location.pathname;
  let { id } = useParams();

  const [currentPage, setCurrentPage] = useState(1);

  const [pagination, setPagination] = useState({
    size: 5, // 한 페이지에 표시될 게시글 수
    rangeSize: 5, // 하단 페이지 사이즈
    totalCount: 0,
    totalPages: 0,
    first: false,
    last: false,
  });

  useEffect(() => {
    getSellList();
  }, [currentPage]); // eslint-disable-line react-hooks/exhaustive-deps

  const [sellList, setSellList] = useState([]);

  const getSellList = async () => {
    try {
      const data = {
        page: Number(currentPage),
        size: Number(pagination.size),
        isMembership: "Inactive",
        paymentFlag: "Active",
        memberId: id,
      };

      const response = (await OrderApi.getListOrder(data)).data.data;

      const processedResponse = response.content.map((item, index) => {
        return {
          ...item,
          numbering:
            response.totalCount - (currentPage - 1) * pagination.size - index,
          checked: false,
          imageIsValid: true,
        };
      });

      const processedDataWithImages = await Promise.all(
        processedResponse.map(
          (item) =>
            new Promise((resolve) => {
              if (item.thumbnailServerFileName) {
                const img = new Image();
                img.src = `${fileUrl}/${item.thumbnailServerFileName}`;

                img.onload = () => {
                  resolve({ ...item, imageIsValid: true });
                };

                img.onerror = () => {
                  resolve({ ...item, imageIsValid: false });
                };
              } else {
                resolve(item);
              }
            })
        )
      );

      setSellList(processedDataWithImages);
      setPagination({
        ...pagination,
        totalCount: response.totalCount,
        totalPages: Math.ceil(response.totalCount / pagination.size),
      });
    } catch (error) {
      errorHandler(error);
    }
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <BuyContainer>
          <BuyHeader>
            <PretendardText
              style={{
                color: "#f3f3f3",
                fontSize: "16px",
                fontWeight: 700,
                lineHeight: "28px",
                letterSpacing: "-0.3%",
              }}
            >
              구매 내역
            </PretendardText>
          </BuyHeader>

          <Table style={{ width: "100%", borderTop: "none" }}>
            <colgroup>
              {/* 합계: 1044px */}
              {/* 체크박스 */}
              {/* <col width="56px" /> */}
              {/* No */}
              {/* <col width="47px" /> */}
              {/* 구매번호/시각 */}
              <col width="187px" />
              {/* 구매 상품 */}
              <col width="265px" />
              {/* 상품 금액 */}
              <col width="97px" />
              {/* 결제 내역 */}
              <col width="174px" />
              {/* 상태 */}
              <col width="123px" />
              {/* 보기 */}
              <col width="95px" />
            </colgroup>
            <tbody>
              {sellList.map((item, index) => {
                return (
                  <Tr
                    key={index}
                    style={{
                      height: "107px",
                      background: "transparent",
                      borderBottom: "0.5px solid rgba(255, 255, 255, 0.12)",
                    }}
                  >
                    {/* <Td></Td>
                  <Td></Td> */}
                    {/* 구매번호/시각 */}
                    <Td>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          flexDirection: "column",
                          gap: 2,
                        }}
                      >
                        <TableText
                          style={{
                            maxWidth: "130px",
                          }}
                        >
                          {item.payNumber}
                        </TableText>
                        <PretendardText
                          style={{
                            fontSize: "13px",
                            fontWeight: "500",
                            lineHeight: "18.75px",
                            color: "rgba(181, 181, 181, 0.5)",
                          }}
                        >
                          {moment(item.createdAt).format("YYYY-MM-DD HH:mm")}
                        </PretendardText>
                      </div>
                    </Td>
                    {/* 구매 상품 */}
                    <Td>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 16,
                        }}
                      >
                        {item.thumbnailServerFileName && item.imageIsValid ? (
                          <img
                            src={`${fileUrl}/${item.thumbnailServerFileName}`}
                            alt="상품 이미지"
                            style={{
                              width: "40px",
                              height: "40px",
                              objectFit: "cover",
                            }}
                          />
                        ) : (
                          <div
                            style={{
                              width: "40px",
                              height: "40px",
                              backgroundColor: "#272829",
                            }}
                          />
                        )}
                        <PretendardText
                          style={{
                            fontSize: "13px",
                            fontWeight: "500",
                            lineHeight: "18.75px",
                            color: "rgba(181, 181, 181, 0.5)",
                            maxWidth: "191px",
                          }}
                        >
                          {item.orderTitle}
                        </PretendardText>
                      </div>
                    </Td>
                    {/* 상품 금액 */}
                    <Td>
                      <TableText>
                        {formatNumberWithCommas(item.totalPay)}원
                      </TableText>
                    </Td>
                    {/* 결제 내역 */}
                    <Td>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          flexDirection: "column",
                          gap: 2,
                        }}
                      >
                        <TableText
                          style={{
                            maxWidth: "112px",
                          }}
                        >
                          실결제 {formatNumberWithCommas(item.realPay)}원
                        </TableText>
                        <PretendardText
                          style={{
                            fontSize: "13px",
                            fontWeight: "500",
                            lineHeight: "18.75px",
                            color: "rgba(181, 181, 181, 0.5)",
                          }}
                        >
                          결제 방법: {item.payMethod}
                        </PretendardText>
                        {item.couponPay > 0 || item.pointPay > 0 ? (
                          <PretendardText
                            style={{
                              fontSize: "13px",
                              fontWeight: "500",
                              lineHeight: "18.75px",
                              color: "rgba(181, 181, 181, 0.5)",
                            }}
                          >
                            포인트 사용/쿠폰 사용
                          </PretendardText>
                        ) : null}
                      </div>
                    </Td>
                    {/* 상태 */}
                    <Td>
                      <TableText
                        style={{
                          textAlign: "center",
                          color: `${
                            item.orderStatus === "PAY_COMPLETE"
                              ? "#009bde"
                              : item.orderStatus === "CANCEL_REQUEST"
                              ? "#cf6679"
                              : "#aaa"
                          }`,
                        }}
                      >
                        {item.orderStatus === "PAY_COMPLETE"
                          ? "결제 완료"
                          : item.orderStatus === "CANCEL_REQUEST"
                          ? "취소 요청"
                          : item.orderStatus === "CANCEL_REJECT"
                          ? "취소 거절"
                          : item.orderStatus === "CANCEL_COMPLETE"
                          ? "취소 완료"
                          : ""}
                      </TableText>
                    </Td>
                    {/* 보기 */}
                    <Td>
                      <DetailBtn
                        style={{
                          background: "#313233",
                        }}
                        onClick={() => {
                          navigate(
                            `${route.shopping_sell_detail}/${item.orderStatus}/${item.id}`
                          );
                          scrollToTop();
                        }}
                      />
                    </Td>
                  </Tr>
                );
              })}
            </tbody>
          </Table>

          {sellList.length > 0 ? null : (
            <Empty style={{ borderBottom: "none" }} />
          )}
        </BuyContainer>

        {/* 페이지네이션 영역 */}
        <Pagination2
          style={{ width: 265, marginTop: 28 }}
          route={``}
          queryString={``}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          totalPages={pagination.totalPages}
          rangeSize={pagination.rangeSize}
          first={pagination.first}
          last={pagination.last}
        />
      </div>
    </>
  );
};

export default BuyList;

const BuyContainer = styled.div.attrs((props) => {})`
  width: 100%;
  height: fit-content;
  min-height: 565px;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 10px;
  background: #272829;
  box-shadow: 2px 2px 10px 0px rgba(0, 0, 0, 0.08);
  padding: 20px 25px;
`;

const BuyHeader = styled.div.attrs((props) => {})`
  width: 100%;
  height: 59px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0px 30px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
`;
